import styled from 'styled-components';
import Flex from '../../atoms/Flex';
export const Container = styled(Flex)`
  cursor: pointer;
`;